import useAxios from './useAxios';
import { useRecoilState } from 'recoil';
import { userState } from '../states/userState';

export function useFetchUser() {
  const { requestAxios } = useAxios();
  const [, setUserState] = useRecoilState(userState);

  const requestUserInfo = async () => {
    try {
      const data = await requestAxios<UserInfo>(true, {
        url: '/users/my-page/',
        method: 'get',
      });
      setUserState((prev) => ({ ...prev, userInfo: data }));
    } catch (error) {
      setUserState((prev) => ({ ...prev, userInfo: null }));
    }
  };

  return { requestUserInfo };
}
